import React, {useEffect, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';

import './App.css';
import * as actions from "./store/actions";

import Auth from "./containers/Auth/Auth";
import Logout from "./containers/Auth/Logout/Logout";
import Layout from "./containers/Layout/Layout";
import TopPosts from "./containers/Posts/TopPosts/TopPosts";
import NewPosts from "./containers/Posts/NewPosts/NewPosts";
import SubmitPost from "./containers/Posts/SubmitPost/SubmitPost";
import UserProfile from "./containers/UserProfile/UserProfile";
import DetailedPost from "./containers/Posts/DetailedPost/DetailedPost";
import NewComments from "./containers/NewComments/NewComments";

function App() {

    const dispatch = useDispatch()
    const tryAutoSignIn = useCallback(() => dispatch(actions.authCheckState()), [dispatch])

    useEffect(() => {
        tryAutoSignIn()
    }, [tryAutoSignIn])

    return (
        <>
            <Layout>
                <Switch>
                    <Route path="/" exact component={TopPosts}/>
                    <Route path="/news" component={TopPosts}/>
                    <Route path="/newest" component={NewPosts}/>
                    <Route path="/post" component={DetailedPost}/>
                    <Route path="/comments" component={NewComments}/>
                    <Route path="/submit" component={SubmitPost}/>
                    <Route path="/user" component={UserProfile}/>
                    <Route path="/auth" component={Auth}/>
                    <Route path="/logout" component={Logout}/>
                    // In case of 404 error
                    <Redirect to="/"/>
                </Switch>
            </Layout>
        </>
    );
}

export default App;
